import React from "react";
import { FaWhatsapp, FaPhoneAlt } from "react-icons/fa";
import "./FloatingContact.css";

const FloatingContact = () => {
  const phoneNumber = "919243024730";

  const handleWhatsApp = () => {
    const message = encodeURIComponent(
      "Hello, I am interested in your property listings."
    );

    window.open(
      `https://wa.me/${phoneNumber}?text=${message}`,
      "_blank",
      "noopener,noreferrer"
    );
  };

  const handleCall = () => {
    window.location.href = `tel:+${phoneNumber}`;
  };

  return (
    <div className="floating-contact">

      {/* WhatsApp */}
      <button
        type="button"
        className="floating-contact-btn whatsapp-btn"
        onClick={handleWhatsApp}
        aria-label="Contact us on WhatsApp"
      >
        <FaWhatsapp className="floating-contact-icon" />
        <span>WhatsApp</span>
      </button>

      {/* Call */}
      <button
        type="button"
        className="floating-contact-btn call-btn"
        onClick={handleCall}
        aria-label="Call Us"
      >
        <FaPhoneAlt className="floating-contact-icon" />
        <span>Call Us</span>
      </button>

    </div>
  );
};

export default FloatingContact;